import { forEach } from 'lodash';
import { UrlService, WindowProxy } from '@sm360/widget-commons-core-services';

class StateManagement {
    addParamToCurrentState(url, widgetName, context, parameterName, value) {
        const windowProxy = WindowProxy.get();
        if (!url || !context || !parameterName || !widgetName || !windowProxy) {
            return;
        }

        let queryParamsString = '';
        const queryParams = UrlService.getUrlParameters();

        queryParams[parameterName] = value;

        forEach(queryParams, (paramValue, name) => {
            const paramSign = !queryParamsString ? '?' : '&';

            if (paramValue) {
                queryParamsString += `${paramSign}${name}=${paramValue}`;
            }
        });

        windowProxy.history.replaceState(context, widgetName, `${url}${queryParamsString}`);
    }
}

export default new StateManagement();
